<label [for]="for" [class.visually-hidden]="isHidden">
  {{ text }}<span *ngIf="isRequiredField">*</span>
  <p *ngIf="helperText" class="small-text">{{ helperText }}</p>
  <span class="tooltip-wrapper">
    <ng-content select="[slot=tooltip]"></ng-content>
  </span>
</label>
